import script from "./LocationInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationInfo.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__